import React from 'react';

import { SpaceContainerStyles } from '~src/spacesPlatform/style/SpaceContainerStyles';

import { ConnectedExplorerToolbar } from '../Explorer/ConnectedExplorerToolbar';
import { SpaceHeaderContent } from './SpaceHeaderContent';

export function CompactSpaceHeaderContent(props: { headerText: string, renderSubHeadingArea?: () => JSX.Element, renderSideContent?: () => JSX.Element, testId?: string }): JSX.Element {
    return <div className={SpaceContainerStyles.MastheadArea + ' ' + SpaceContainerStyles.WithExplorerToolbar}>
        <div className={SpaceContainerStyles.HeaderClassName}>
            <SpaceHeaderContent headerText={props.headerText} renderSideContent={props.renderSideContent} testId={props.testId} />
            {
                props.renderSubHeadingArea && <div style={SpaceContainerStyles.MastheadSubheadingArea}>
                    {props.renderSubHeadingArea()}
                </div>
            }
        </div>
        <div className={SpaceContainerStyles.ExplorerToolbarClassName}>
            <ConnectedExplorerToolbar skipHorizontalMargin={true} />
        </div>
    </div>;
}